// @flow

import * as React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { connect, type Connector } from 'react-redux'

import { getAllowedCampaigns, setCurrentCampaign } from '../store/allowed-campaigns'
import type { ReduxAction, ReduxState, Dispatch } from '../store'

type OwnProps = {
  style: Object,
  onChangeAction: ReduxAction,
}

type MappedProps = {
  allowedCampaigns: Array<string>,
  currentCampaign: string,
  loading: boolean,
}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    allowedCampaigns: state.allowedCampaigns.allowedCampaigns,
    currentCampaign: state.allowedCampaigns.currentCampaign,
    loading: state.allowedCampaigns.loading,
  }
}

type _Props = { dispatch: Dispatch } & OwnProps & MappedProps
type Props = _Props & $Shape<_Props>

export class CampaignsDropdown extends React.Component<Props> {
  static defaultProps = {
    style: {},
    onChangeAction: { type: 'NOOP' },
  }

  onChangeCampaign = (e: SyntheticEvent<*>, element: React.Element<*>) => {
    if (!element.value) return
    this.props.dispatch(setCurrentCampaign(element.value))
    this.props.dispatch(this.props.onChangeAction)
  }

  onOpen = async () => {
    this.props.dispatch(getAllowedCampaigns())
  }

  render() {
    let campaignOptions = []
    for (let c of this.props.allowedCampaigns) {
      campaignOptions.push({
        key: c,
        value: c,
        text: c,
      })
    }
    return (
      <Dropdown
        scrolling
        selection
        floating
        size="small"
        value={this.props.currentCampaign}
        options={campaignOptions}
        selectOnBlur={false}
        text={this.props.currentCampaign}
        placeholder="Campagna..."
        noResultsMessage="Nessun risultato."
        onChange={this.onChangeCampaign}
        onOpen={this.onOpen}
        style={this.props.style}
        loading={this.props.loading}
      />
    )
  }
}

const connector: Connector<OwnProps & $Shape<OwnProps>, MappedProps & $Shape<MappedProps>> = connect(
  mapStateToProps,
  null
)
export default connector(CampaignsDropdown)



// WEBPACK FOOTER //
// ./src/systemwide/allowed-campaigns-dropdown.js